import React from 'react'
import { Dialog, Transition, Popover } from "@headlessui/react";
import { Fragment } from 'react';
import {Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { FC, useState, useEffect } from 'react';
import axios from "axios";
import { API_URL } from 'api/config';
import { toast } from 'react-toastify';

export interface ReceiptPopoverProps {
  isPopoverOpen: boolean;
  setIsPopoverOpen: any;
  receiptId:any;
  // propertyName:String;
  maxGuests: number;
  setIsPdfGenerated:any;
  getReceiptRequests:any;

}
interface ReceiptData {

  // numOfGuest: string;
  // invoiceNum: string;
  // gstNumber: string;
  //booking info
  bookingId?: string;
    //Date of issue: string;
  //guest Details
  guestName: string;
  email?: string;
  phone?: string;
  //property details
  propertyName?: string;
  propertyAddress?: string;
  hostName?: string;
  hostContact?: string;
  //booking summary
  checkinDate: string;
  checkoutDate: string;
  totalNights?: number;
  //payment summary
  totalPrice?: Number;
  paymentStatus?: string;
  //
  addMoreInfo: { name: string; value: string }[];
  //Notes
  notes?: string;
}
const ReceiptPopover: FC<ReceiptPopoverProps> = ({ isPopoverOpen, setIsPopoverOpen, receiptId, maxGuests,setIsPdfGenerated, getReceiptRequests }) => {
const token = localStorage.getItem('token');
const [isGenerating, setIsGenerating] = useState(false);
const [initialFormValues, setInitialFormValues] = useState<ReceiptData>({
  bookingId: "",
  guestName: "",
  email: "",
  phone: "",
  //property details
  propertyName: "",
  propertyAddress: "",
  hostName: "",
  hostContact: "",
  //booking summary
  checkinDate: "",
  checkoutDate: "",
  totalNights: 0,
  //payment summary
  totalPrice: undefined,
  // paymentStatus: "",
  //
  addMoreInfo: [{ name: "", value: "" }],
  //Notes
  notes: ""
});
   const validationSchema = Yup.object().shape({
      bookingId: Yup.string().required("Booking ID is required"),
      guestName: Yup.string().required("Guest name is required"),
      email: Yup.string().email("Invalid email format").required("Email is required"),
      phone: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
      .required("Phone number is required"),
      //property details
      propertyName: Yup.string().required("Property name is required"),
      propertyAddress: Yup.string().required("Property address is required"),
      hostName: Yup.string().required("Host name is required"),
      hostContact: Yup.string().required("Host contact is required"),
      //booking summary
      checkinDate: Yup.date().required("Check-in date is required"),
      checkoutDate: Yup.date()
        .required("Check-out date is required")
        .min(
          Yup.ref("checkinDate"),
          "Checkout date must be after check-in date"
        ).test(
          "is-same",
          "Check-in and checkout date cannot be the same",
          function (checkoutDate) {
            const { checkinDate } = this.parent;
            return checkoutDate !== checkinDate;
          }
        ),
      totalNights: Yup.number().min(1, "Total nights must be at least 1").required("Total nights is required"),
      //payment summary
      totalPrice: Yup.number().typeError("totalPrice must be a number").positive("totalPrice must be greater than zero").required("totalPrice is required"),
      // paymentStatus: Yup.string().required("Payment status is required"),
    });
  
  const fetchReceiptData = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/receipt/get-receipt/${receiptId}`,
        {
          headers: {
            token: token,
          },
        }
      );
      const data = response.data.receiptData;
        const formattedData = {
          guestName: data.guestName || "",
          checkinDate: data.checkinDate ? new Date(data.checkinDate).toISOString().split('T')[0] : "",
          checkoutDate: data.checkoutDate ? new Date(data.checkoutDate).toISOString().split('T')[0] : "",
          //set totalnights the difference between checkin and checkout date
          // totalNights: data.totalNights ? data.totalNights : 0,
          totalPrice: data.totalPrice !== undefined ? data.totalPrice : 0,
          addMoreInfo: data.addMoreInfo || [],
          bookingId: data.bookingId || "",
          email: data.email || "",
          phone: data.phone || "",
          propertyName: data.propertyName || "",
          propertyAddress: data.propertyAddress || "",
          hostName: data.hostName || "",
          hostContact: data.hostContact || "",
          totalNights: data.totalNights !== undefined ? data.totalNights : 0,
          paymentStatus: data.paymentStatus || "",
          // addMoreInfo: Array.isArray(data.addMoreInfo) ? data.addMoreInfo : [{ name: "", value: "" }],
          notes: data.notes || "",

                };
        setInitialFormValues(formattedData);

 
    } catch (error) {
      toast.error("Failed to load receipt data");
      setInitialFormValues({
          guestName: "",
          email: "",
          phone: "",
          propertyName: "",
          propertyAddress: "",
          hostName: "",
          hostContact: "",
          checkinDate: "",
          checkoutDate: "",
          totalNights: 0,
          totalPrice: 0,
          // paymentStatus: "",
          addMoreInfo: [{ name: "", value: "" }],
          notes: "",
        });
    }
  };

  useEffect(() => {
    if (isPopoverOpen && receiptId) {
      fetchReceiptData();
    } else {
      // Reset initial values when the popover is closed or no receiptId
      setInitialFormValues({
          guestName: "",
          email: "",
          phone: "",
          propertyName: "",
          propertyAddress: "",
          hostName: "",
          hostContact: "",
          checkinDate: "",
          checkoutDate: "",
          totalNights: 0,
          totalPrice: 0,
          // paymentStatus: "",
          addMoreInfo: [{ name: "", value: "" }],
          notes: "",
        });

    }
  }, [isPopoverOpen, receiptId]);
  const handleSubmit = async (values: any) => {
    try {      
      setIsGenerating(true);
      setIsPopoverOpen(false);

      const response = await axios.post(
        `${API_URL}/receipt/fullfill-request`,
        { ...values, receiptId },
        {    
            headers: {
            token: token,
          },
        }
      );
      if (response.data.error === "false") {
        toast.success("Receipt generated successfully.You can now download it.");
        getReceiptRequests();
        setIsPdfGenerated(true);
        localStorage.setItem("isPdfGenerated", "true");
      } else {
        response.data.message ? toast.error(response.data.message) : toast.error("Failed to generate pdf");
      }

    } catch (error) {
      console.log("error downloading pdf", error);
      toast.error("Error downloading receipt");
    } finally {
      setIsPopoverOpen(false);
      setIsGenerating(false);
    }
  };
  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <Popover className="relative !z-max">
        {({ open }) => (
          <>
            <Transition
              as={Fragment}
              show={isPopoverOpen}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-4"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 -translate-y-4"
            >
              <Popover.Panel className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white p-5 rounded-md shadow-lg w-96 max-h-[70vh] overflow-y-auto">
                  <h4 className="text-lg font-semibold mb-4">
                    Receipt Request Form
                  </h4>
                    <Formik
                      enableReinitialize
                      initialValues={initialFormValues}
                      validationSchema={validationSchema}
                      onSubmit={handleSubmit}
                    >
                      {({ isSubmitting, values, setFieldValue }) => (
                        <>
                          <Form>
                            <div className="mt-4">
                              <label className="block font-medium mb-2">
                                Booking Info
                              </label>
                              <Field
                                type="text"
                                name="bookingId"
                                placeholder="Booking ID"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  setFieldValue("bookingId", e.target.value);
                                }}
                              />
                              <ErrorMessage
                                name="bookingId"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <label className="block font-medium mb-2">
                                Guest Info
                              </label>
                              <Field
                                type="text"
                                name="guestName"
                                placeholder="Guest Name"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  setFieldValue("guestName", e.target.value);
                                }}
                              />
                              <ErrorMessage
                                name="guestName"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <Field
                                type="text"
                                name="email"
                                placeholder="Email"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  setFieldValue("email", e.target.value);
                                }}
                              />
                              <ErrorMessage
                                name="email"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <Field
                                type="tel"
                                name="phone"
                                placeholder="Phone Number"
                                maxLength={10}
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  setFieldValue("phone", e.target.value);
                                }}
                              />
                              <ErrorMessage
                                name="phone"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <label className="block font-medium mb-2">
                                Property Details
                              </label>
                              <Field
                                type="text"
                                name="propertyName"
                                placeholder="Property Name"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  setFieldValue("propertyName", e.target.value);
                                }}
                              />
                              <ErrorMessage
                                name="propertyName"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <Field
                                type="text"
                                name="propertyAddress"
                                placeholder="Property Address"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  setFieldValue("propertyAddress", e.target.value);
                                }}
                              />
                              <ErrorMessage
                                name="propertyAddress"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <Field
                                type="text"
                                name="hostName"
                                placeholder="Host Name"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  setFieldValue("hostName", e.target.value);
                                }}
                              />
                              <ErrorMessage
                                name="hostName"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <Field
                                type="text"
                                name="hostContact"
                                placeholder="Host Contact"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  setFieldValue("hostContact", e.target.value);
                                }}
                              />
                              <ErrorMessage
                                name="hostContact"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <label className="block font-medium mb-2">
                                Booking Summary
                              </label>
                              <Field
                                type="date"
                                id="datePicker"
                                name="checkinDate"
                                onChange={(e: any) =>
                                  setFieldValue("checkinDate", e.target.value)
                                }
                                value={values.checkinDate}
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                              />
                              <ErrorMessage
                                name="checkinDate"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <Field
                                type="date"
                                name="checkoutDate"
                                onChange={(e: any) => {
                                  setFieldValue("checkoutDate", e.target.value);
                                  setFieldValue("totalNights", values.checkinDate ? Math.ceil((new Date(e.target.value).getTime() - new Date(values.checkinDate).getTime()) / (1000 * 3600 * 24)) : 0);
                                }}
                                value={values.checkoutDate}
                                min={values.checkinDate}
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                              />
                              <ErrorMessage
                                name="checkoutDate"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <Field
                                type="text"
                                name="totalNights"
                                placeholder="Total Nights"
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                                onChange={(e: any) => {
                                  setFieldValue("totalNights", e.target.value);
                                }}
                                disabled={true}
                              />
                              <ErrorMessage
                                name="totalNights"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            <div className="mt-4">
                              <label className="block font-medium mb-2">
                                Payment Summary
                              </label>
                              <Field
                                type="number"
                                name="totalPrice"
                                placeholder="Total Price"
                                onChange={(e: any) => {
                                  const value = e.target.value;
                                  const numericValue = value
                                    ? Number(value.replace(/\D/g, ""))
                                    : "";
                                  setFieldValue("totalPrice", numericValue);
                                }}
                                value={values.totalPrice}
                                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm p-2 bg-white"
                              />
                              <ErrorMessage
                                name="totalPrice"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                            {/* ADD MORE FIELDS */}
                            <div className="mt-4">
                              <label className="block font-medium mb-2">
                                Notes
                              </label>
                              <Field
                                name="notes"
                                placeholder="Add any additional notes"
                                className="border-gray-300 rounded-md shadow-sm p-2 bg-white w-full"
                              />
                              <ErrorMessage
                                name="notes"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                              />
                            </div>
                                                        <div className="py-2">
                              <label className="block font-medium mt-2">
                                Additional Info
                              </label>
                              <FieldArray name="addMoreInfo">
                                {(arrayHelpers) => (
                                  <div>
                                    {values.addMoreInfo?.map(
                                      (item, index: any) => (
                                        <div
                                          key={index}
                                          className="flex gap-2 mt-2 items-center"
                                        >
                                          <Field
                                            name={`addMoreInfo[${index}].name`}
                                            placeholder="Field Name"
                                            className="border-gray-300 rounded-md shadow-sm p-2 bg-white w-1/2"
                                          />
                                          <Field
                                            name={`addMoreInfo[${index}].value`}
                                            placeholder="Field Value"
                                            className="border-gray-300 rounded-md shadow-sm p-2 bg-white w-1/2"
                                          />
                                          <button
                                            type="button"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                            className="text-red-500 text-base font-bold"
                                          >
                                            ✕
                                          </button>
                                        </div>
                                      )
                                    )}
                                    <button
                                      type="button"
                                      onClick={() =>
                                        arrayHelpers.push({
                                          name: "",
                                          value: "",
                                        })
                                      }
                                      className="mt-2 text-blue-600"
                                    >
                                      + Add More
                                    </button>
                                  </div>
                                )}
                              </FieldArray>
                            </div>
                            {/* SUBMIT AND CANCEL BUTTONS */}
                            <div className="mt-4 flex justify-end space-x-2">
                              <button
                                type="button"
                                onClick={() => setIsPopoverOpen(false)}
                                className="px-4 py-2 bg-gray-300 rounded-md"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                disabled={isSubmitting}
                                className="px-4 py-2 bg-custom-color text-white rounded-md"
                              >
                                Generate PDF
                              </button>
                            </div>
                          </Form>
                        </>
                      )}
                    </Formik>
                  
                  {!initialFormValues && (
                    <div>Could not load receipt data.</div>
                  )}
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
      {isGenerating && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
          <div className="bg-white px-6 py-4 rounded-md shadow-lg flex flex-col items-center gap-2">
            <svg
              className="animate-spin h-6 w-6 text-blue-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
            <p className="text-gray-700 mt-2 text-sm">Generating PDF...</p>
          </div>
        </div>
      )}
    </>
  );
}

export default ReceiptPopover